import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyIsOfficeSharePointLink, lazyIsSharePointLink } from 'owa-sharepoint-link-detector';
import { LinkProviderType } from '../types/LinkProviderType';
import {
    isBoxLink,
    isDropboxLink,
    isGDriveLink,
    isOneDriveConsumerLink,
} from './checkSharingLinkUrlDomain';

export async function getLinkProviderType(url: string): Promise<LinkProviderType> {
    const isSharePointLink = await lazyIsSharePointLink.import();
    if (isSharePointLink(url)) {
        return LinkProviderType.OneDrivePro;
    }

    const isOfficeSharePointLink = await lazyIsOfficeSharePointLink.import();
    if (isOfficeSharePointLink(url)) {
        return LinkProviderType.OfficeOneDrivePro;
    }

    if (await isOneDriveConsumerLink(url)) {
        return LinkProviderType.OneDriveConsumer;
    }

    if (!isFeatureEnabled('doc-link-filePicker')) {
        return null;
    }

    if (await isDropboxLink(url)) {
        return LinkProviderType.Dropbox;
    }

    if (await isBoxLink(url)) {
        return LinkProviderType.Box;
    }

    if (await isGDriveLink(url)) {
        return LinkProviderType.GDrive;
    }

    return null;
}
